/** Configurações padrões do ECharts */


/** Configuração padrão do textStyle global */
export const textStyleDefault = {
    fontFamily: 'Montserrat'
};

/** Configuração padrão do title */
export const titleDefault = {
    textStyle: {
        color: '#626262',
        fontWeight: '600',
        fontSize: 14
    },
    subtextStyle: {
        color: '#959595',
        fontSize: 12,
        fontWeight: '600'
    }
};

/** Configuração padrão do toolbox */
export const toolboxDefault = {
    show: true,
    feature: {
        saveAsImage: {
            title: 'Download'
        },
    },
    iconStyle: {
        normal: {
            borderColor: '#cccccc',
        },
        emphasis: {
            borderColor: '#237dd8',
        }
    },
    right: 20
}

/** Configuração padrão do tooltip */
export const tooltipDefault = {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    textStyle: {
        fontSize: 12
    }
};

/** Cria o icone com a cor da series do chart para exibir no tooltip igual ao apresentado por padrão o eCharts */
export function createTooltipColorIcon(color: string): string {
    return `<span style="display:inline-block; margin-top:2px; width:10px; height:10px; border-radius:10px;background-color:${color}"></span>`;
}

/** Configuração padrão do loading */
export const loadingDefault = {
    text: 'carregando...',
    color: '#dadee0',
    textColor: '#dadee0'
};

/** Configuração padrão dos gráficos do tipo pie (pizza/torta) */
export const pieDefault = {
    type: 'pie',
    itemStyle: {
        emphasis: {
            shadowBlur: 30,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
        }
    }
}
